import { render, staticRenderFns } from "./mo-pageheader.vue?vue&type=template&id=67f9f9dc&scoped=true&"
import script from "./mo-pageheader.vue?vue&type=script&lang=js&"
export * from "./mo-pageheader.vue?vue&type=script&lang=js&"
import style0 from "./mo-pageheader.vue?vue&type=style&index=0&id=67f9f9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f9f9dc",
  null
  
)

export default component.exports